import Infothek from './main';
import resultTemplate from './../../templates/partials/organisms/ST06_InfothekKontakte/vue-result-template.hbs';
import selectedFilterTemplate from './../../templates/partials/organisms/ST06_InfothekNeuigkeiten/vue-selected-filter-template.hbs';

class BfvInfothekKontakte extends Infothek {
  constructor(options = {}) {
    Object.assign(options, {
      vue: {
        results: {
          template: resultTemplate,
          el: '#bfv-infothek-kontakte__results',
        },
        selectedFilter: {
          template: selectedFilterTemplate,
          el: '#bfv-infothek-kontakte__selected-filter',
        },
      },
    });
    super(options);

    this.apiConfig = Object.assign(this.apiConfig, {
      route: this.$root.getAttribute('data-api-route'),
    });

    this.resultComponentInitalData = Object.assign(this.resultComponentInitalData, {
      labels: JSON.parse(this.$root.getAttribute('data-labels')),
    });
  }

  dataLoaded() {
    this.vueResultComponent.updateData(this.data);
    this.updateTotalHits();
  }

  init() {
    this.loadData();
  }
}

export default BfvInfothekKontakte;



// WEBPACK FOOTER //
// ./src/javascript/infothek/kontakte.js